import SecureLS from "secure-ls";

const secureStorage = new SecureLS({ encodingType: "aes" });

// class LS {
//   ls;

//   constructor() {
//     this.ls = window.localStorage;
//   }

//   get(key) {
//     return JSON.parse(this.ls.getItem(key));
//   }

//   set(key, data) {
//     this.ls.setItem(key, JSON.stringify(data));
//   }

//   remove(key) {
//     this.ls.removeItem(key);
//   }

//   removeAll() {
//     this.ls.clear();
//   }

//   clear() {
//     this.ls.clear();
//   }
// }

// const secureStorage = new LS();

export default secureStorage;
